import { SampleBooksService } from 'src/app/acumatica/EntityServices/SampleBooks.service';
import { KitStockComponent } from './../../../acumatica/EntityServices/KitSpecification.service';
import { ConfirmationDialog } from './../../../common/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MayerFabricsService } from 'src/app/services/mayer-fabrics.service';
import { SalesOrder, SalesOrderService } from './../../../acumatica/EntityServices/SalesOrder.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { AcumaticaLoadingDialogComponent } from 'src/app/acumatica/loading-indicator/loading-dialog-indicator.component';
import { ShipmentService } from 'src/app/acumatica/EntityServices/Shipment.service';

@Component({
  selector: 'app-fill-rep-cards',
  templateUrl: './fill-rep-cards.component.html',
  styleUrls: ['./fill-rep-cards.component.css']
})
export class FillRepCardsComponent implements OnInit {
  pageTitle = new FormControl('Fill Cards from Supply');
  order?: SalesOrder;

  review: {
    [binder: string]: KitStockComponent[]
  } = {};

  constructor(
    public binders: SampleBooksService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private salesOrders: SalesOrderService,
    private shipments: ShipmentService,
    private mayerfabrics: MayerFabricsService
  ) {

  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      let orderNbr = params.get('orderNbr');
      if (!orderNbr) { this.gotoBinderList(); return; }

      setTimeout(() => { this.pageTitle.setValue(orderNbr); });

      let dialogRef = this.dialog.open(AcumaticaLoadingDialogComponent, {
        data: {
          message: "Verifying Sales Order"
        }
      });

      let updatedReview: {
        [binder: string]: KitStockComponent[]
      } = {}

      this.binders.GetAllBindersContents().subscribe(() => {
        dialogRef.close();

        this.salesOrders.get('SO', orderNbr!, { expand: 'Details', loader: null }).subscribe(so => {
          so.Details = so.Details!.filter(line => line.WarehouseID == this.mayerfabrics.RepWarehouseID);
          this.order = so;

          // when no items to be placed from sales rep's supply we're all done
          if (so.Details.length == 0) {
            this.router.navigate(['/customer-info', so.CustomerID]);
          }

          so.Details!.forEach(line => {
            let binder = this.binders.FindContainingBinder(line.InventoryID);

            let binderID = binder!.Binder.InventoryID!;
            updatedReview[binderID] = updatedReview[binderID] || [];
            updatedReview[binderID].push(binder!.Component);

          });
          this.review = updatedReview;
        });
      });
    });
  }

  gotoBinderList() { this.router.navigate(['/binder-audit']); }

  shipCardFromWarehouse(inventoryID: string) {
    let line = this.order?.Details?.find(line => line.InventoryID == inventoryID)!;

    this.dialog.open(ConfirmationDialog, {
      data: {
        icon: 'help',
        message: "Change " + line.InventoryID + " - " + line.LineDescription + " to ship from the Warehouse instead of your supply?",
        confirmText: 'Yes, change it',
        cancelText: 'No, cancel that'
      }
    }).afterClosed().subscribe(response => {
      if (response) {
        // update the sales order
        let updateSO = new SalesOrder({
          OrderType: this.order?.OrderType,
          OrderNbr: this.order?.OrderNbr
        });
        line.WarehouseID = "03";
        updateSO.Details = [line];

        this.salesOrders.put(updateSO, { loader: "Updating Sales Order" }).subscribe(() => {
          this.order?.Details?.remove(line);
          let container = this.binders.FindContainingBinder(inventoryID);
          let binderID = container!.Binder.InventoryID!;
          let reviewBinder = this.review[binderID!];
          let componentCard = reviewBinder.find(card => card.InventoryID = inventoryID);
          reviewBinder.remove(componentCard);
          if (reviewBinder.length == 0) {
            delete (this.review[binderID]);
            this.review = Object.assign({}, this.review);
          }
        });
      }
    });
  }

  confirmRepPlacement() {
    let whseID = this.mayerfabrics.RepWarehouseID;
    if (!whseID) return;
    let dialogRef = this.dialog.open(AcumaticaLoadingDialogComponent);

    dialogRef.componentInstance.message = "Creating Shipment";
    this.shipments.createShipment(
      this.order!.OrderType,
      this.order!.OrderNbr,
      whseID,
      false).subscribe(soshipment => {

        this.shipments.get(soshipment.ShipmentNbr, { loader: null }).subscribe(shipment => {
          dialogRef.componentInstance.message = "Updating Quantities";
          shipment.DoNotAutoPrintPickList = true;
          shipment.Details.forEach(detail => {
            let alloc = detail.NewAllocation();
            alloc.Qty = 1;
          });
          this.shipments.put(shipment, { loader: null }).subscribe(updatedShipment => {
            dialogRef.componentInstance.message = "Confirming Shipment";
            this.shipments.confirmShipment(updatedShipment, { loader: null }).subscribe(() => {
              dialogRef.close();
              this.binders.resetAudit();
              this.router.navigate(['/customer-info', this.order?.CustomerID]);
            });
          });
        });

      })
  };
}